function debounce(func, delay) {
	let debounceTimer;
	return function () {
		const context = this;
		const args = arguments;
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => func.apply(context, args), delay);
	};
}

$(window).on('load', () => {
	const pagesArray = [
		'members:login',
		'members:lost-password',
		'members:lost-password-reset',
		'join',
		'error:forbidden'
	];
	const page = $('body').data('page');
	let visibleInput, svh;

	if (pagesArray.includes(page)) return;

	// TODO: remove logs

	$('.js-search').each(function () {
		const search = $(this);
		const input = search.find('input');
		const list = search.find('.search-whisper-wrapper');
		let initialized = false;
		let currentFocusIndex = -1;
		let arrowKeyUsed = false;
		let searchIsOpen = false;
		let inputCleared = false;

		const performSearch = debounce(function (query) {
			search.addClass('loading');

			triggerGAEvent('search_typing', 'input-element', { search_term: query });

			$.ajax({
				url: window.settings.urls.whisperUrl,
				method: 'GET',
				data: { q: query },
				success: data => {
					list.empty();
					list.html(data.html);
				},
				complete: () => {
					setTimeout(() => {
						search.removeClass('loading');
						search.addClass('ready');

						if (search.hasClass('open')) {
							svh = window.visualViewport.height;
							document.documentElement.style.setProperty('--svh', `${svh}px`);
						}
					}, 50);
					jQuery.initExitLinks(); // Reinitialize exit link params
				}
			});
		}, 300);

		const openSearch = searchQuery => {
			search.addClass('open');
			searchIsOpen = true;
			if (!initialized) {
				initialized = true;
				performSearch(searchQuery);
			}

			document.documentElement.style.setProperty('--svh', `${svh}px`);
			document.addEventListener('touchmove', preventTouchMove, { passive: false });
			document.addEventListener('wheel', preventTouchMove, { passive: false });
		};

		const closeSearch = () => {
			search.removeClass('open');
			searchIsOpen = false;
			currentFocusIndex = -1;
			document.removeEventListener('touchmove', preventTouchMove);
			document.removeEventListener('wheel', preventTouchMove);
			document.documentElement.style.removeProperty('--svh');
		};

		const isMobile = window.innerWidth < 600;
		const scrollToPosition = function () {
			const searchElement = search.get(0);
			const mobileGap = search.hasClass('open') ? 12 : 82;
			const rect = searchElement.getBoundingClientRect();
			const offset = window.scrollY || window.pageYOffset;
			const top = isMobile ? rect.top + offset - mobileGap : rect.top + offset - 100;

			setTimeout(() => {
				window.scrollTo({
					top: top
				});
			}, 100);
		};

		const preventTouchMove = event => {
			const target = event.target;

			const whisperElement = search.find('.search-whisper').get(0);
			const whisperTarget = whisperElement && whisperElement.contains(target);

			if (whisperTarget) {
				const scrollHeight = whisperElement.scrollHeight;
				const clientHeight = whisperElement.clientHeight;

				if (!(scrollHeight > clientHeight)) {
					event.preventDefault();
				}
			} else {
				event.preventDefault();
			}
		};

		let preventBlur = false;
		const preventBlurTimeout = () => {
			preventBlur = true;
			setTimeout(() => {
				preventBlur = false;
			}, 500);
		};

		input.on('blur', e => {
			setTimeout(() => {
				if (searchIsOpen && !inputCleared) {
					closeSearch();
				}
			}, 150);
		});

		input.on('input', () => {
			const searchQuery = input.val();
			performSearch(searchQuery);
			inputCleared = false;
		});

		$(this).on('click', e => {
			const clear = $(e.target).closest('.input-clear');
			if (clear.length) {
				e.stopPropagation();
				input.focus();
				input.val('');
				inputCleared = true;
				performSearch(input.val());
				return;
			}

			const searchForm = $(e.target).closest('.search-form__input');
			if (searchForm.length) {
				if (!searchIsOpen) {
					openSearch(input.val());
					if (input.attr('id') === 'search-content') {
						scrollToPosition();
					}
				}
				return;
			}

			if (preventBlur) {
				return;
			}

			if (searchIsOpen) {
				const whisperItem = $(e.relatedTarget).closest('.exit');
				const anchor = $(e.relatedTarget).closest('a');
				if (whisperItem.length || anchor.length) {
					e.stopPropagation();
					return;
				}

				const searchClose = $(e.relatedTarget).closest('.search-close');
				if (searchClose.length) {
					e.stopPropagation();
					closeSearch();
					return;
				}
			}
		});

		input.on('keydown', e => {
			const items = list.find('li');

			if (e.key === 'ArrowDown') {
				e.preventDefault();
				arrowKeyUsed = true;
				currentFocusIndex = (currentFocusIndex + 1) % items.length;
				items.removeClass('focused');
				$(items[currentFocusIndex]).addClass('focused');
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				arrowKeyUsed = true;
				currentFocusIndex = (currentFocusIndex - 1 + items.length) % items.length;
				items.removeClass('focused');
				$(items[currentFocusIndex]).addClass('focused');
			} else if (e.key === 'Enter') {
				if (arrowKeyUsed && currentFocusIndex >= 0) {
					e.preventDefault();
					let link = $(items[currentFocusIndex]).find('a').first();
					window.location.href = link.attr('href');
				} else {
					// Submit the form if no arrow key was used
					e.preventDefault();
					input.closest('form').submit();
				}
			} else if (e.key === 'Escape') {
				input.blur();
			}
		});
	});

	const handleKeyPress = debounce(function (e, targetInput) {
		let code = e.keyCode || e.which;
		const activeElement = document.activeElement;
		const isInputOrTextarea = activeElement.nodeName === 'INPUT' || activeElement.nodeName === 'TEXTAREA';

		if (isInputOrTextarea) return;
		if (e.metaKey || e.ctrlKey) return; // Check if Cmd (Mac) or Ctrl (Windows) key is pressed

		if (
			(code >= 65 && code <= 90) || // KeyA to KeyZ
			(code >= 48 && code <= 57) || // Digit0 to Digit9
			(code >= 96 && code <= 105)
		) {
			// Numpad0 to Numpad9
			let keyString = e.key;
			targetInput.val(targetInput.val() + keyString).focus();
		}
		if (code === 27) {
			// Esc key
			targetInput.blur();
			targetInput.closest('.js-search').removeClass('open');
		}
	}, 50);

	document.addEventListener('contentSearchVisible', event => {
		const contentSearchVisible = event.detail.isVisible;
		const visibleInputId = contentSearchVisible ? 'search-content' : 'search-header';

		visibleInput = $(document.getElementById(visibleInputId));

		$(document).on('keydown', function (event) {
			if (visibleInput.length && !visibleInput.is(':focus')) {
				handleKeyPress(event, visibleInput);
			}
		});
	});
});

$(window).on('load', () => {
	// ... existing code ...
});
